var _CpAskRedHat_instances, _CpAskRedHat_healthCheck, _CpAskRedHat_checkAccess;
import { __classPrivateFieldGet, __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators/custom-element.js';
import { property } from 'lit/decorators/property.js';
import { state } from 'lit/decorators/state.js';
import { css } from "lit";
const styles = css `:host{--_gradient:linear-gradient(to right,\n    var(--rh-color-brand-red-light, #f56d6d),\n    var(--rh-color-purple-40, #876fd4),\n    var(--rh-color-purple-60, #3d2785));display:contents;color-scheme:only light}@media (min-width:768px){:host{color-scheme:only dark}}svg{width:var(--rh-size-icon-01,16px);height:var(--rh-size-icon-01,16px);fill:var(--rh-color-purple-60,#3d2785)}@media (min-width:768px){svg{fill:var(--rh-color-purple-20,#d0c5f4)}}a{display:flex;flex-direction:row;position:relative;width:fit-content;gap:var(--rh-space-md,8px);block-size:max-content;inline-size:max-content;align-items:center;text-decoration:none;padding:var(--rh-space-sm,6px) var(--rh-space-md,8px);border:var(--rh-border-width-sm,1px) solid var(--rh-color-border-subtle,light-dark(var(--rh-color-border-subtle-on-light,#c7c7c7),var(--rh-color-border-subtle-on-dark,#707070)));border-radius:var(--rh-border-radius-default,3px);font-size:var(--rh-font-size-body-text-md, 1rem);color:var(--rh-color-text-primary,light-dark(var(--rh-color-text-primary-on-light,#151515),var(--rh-color-text-primary-on-dark,#fff)))}a:before{--_mask:conic-gradient(#000000 0 0);content:"";position:absolute;inset:-1px;border-radius:inherit;padding:var(--rh-border-width-sm,1px);background:var(--_gradient);mask:var(--_mask) content-box exclude,var(--_mask);z-index:1}a:is(:hover,:focus-visible){background-color:light-dark(var(--rh-color-surface-lighter,#f2f2f2),var(--rh-color-surface-darker,#1f1f1f))}a:is(:hover,:focus-visible):before{--_mask:conic-gradient(#000000 0 0);padding:2px}a:is(:focus-visible,:hover:focus-visible,:active){outline:var(--rh-border-width-md,2px) solid var(--rh-color-interactive-primary-default,light-dark(var(--rh-color-interactive-primary-default-on-light,#0066cc),var(--rh-color-interactive-primary-default-on-dark,#92c5f9)));outline-offset:3px;border-radius:var(--rh-border-radius-default,3px)}@media (min-width:768px){a{margin:0 var(--rh-space-2xl,32px) 0 0}}`;
/**
 * Ask Red Hat
 * @slot - Place element content here
 */
let CpAskRedHat = class CpAskRedHat extends LitElement {
    constructor() {
        super(...arguments);
        _CpAskRedHat_instances.add(this);
        this.href = 'https://access.redhat.com/ask';
        this.hasAccess = false;
    }
    async updated() {
        if (await __classPrivateFieldGet(this, _CpAskRedHat_instances, "m", _CpAskRedHat_healthCheck).call(this)) {
            this.hasAccess = await __classPrivateFieldGet(this, _CpAskRedHat_instances, "m", _CpAskRedHat_checkAccess).call(this);
        }
    }
    render() {
        return html `
      ${this.hasAccess ? html `
        <a href="${this.href}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="m30.155 17.267-9.422-2-2-9.422a.75.75 0 0 0-1.466 0l-2 9.422-9.422 2a.75.75 0 0 0 0 1.466l9.422 2 2 9.422a.75.75 0 0 0 1.466 0l2-9.422 9.422-2a.75.75 0 0 0 0-1.466ZM6 11.75a.75.75 0 0 0 .733-.595l.775-3.647 3.647-.775a.75.75 0 0 0 0-1.466l-3.647-.775L6.733.845a.75.75 0 0 0-1.466 0l-.775 3.647-3.647.775a.75.75 0 0 0 0 1.466l3.647.775.775 3.647A.75.75 0 0 0 6 11.75Z"></path></svg>
          Ask Red Hat
        </a>
      ` : ``}
    `;
    }
};
_CpAskRedHat_instances = new WeakSet(), _CpAskRedHat_healthCheck = async function _CpAskRedHat_healthCheck() {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
        controller.abort();
        return false;
    }, 10000);
    if (!this.healthCheckEndpoint) {
        return false;
    }
    const url = this.healthCheckEndpoint;
    try {
        const healthCheckApiResponse = await fetch(url, {
            signal: controller.signal,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        if (!healthCheckApiResponse.ok) {
            return false;
        }
        const json = await healthCheckApiResponse.json();
        const status = json.status === 'OK';
        if (status) {
            clearTimeout(timeoutId);
        }
        return status;
    }
    catch (error) {
        return false;
    }
}, _CpAskRedHat_checkAccess = async function _CpAskRedHat_checkAccess() {
    if (!this.hydraEndpoint || !this.authToken || !this.userId) {
        sessionStorage.removeItem('ifd-access');
        return false;
    }
    const sessionStore = sessionStorage.getItem('ifd-access');
    if (sessionStore !== null) {
        return (sessionStore === 'true');
    }
    else {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => {
            controller.abort();
            return false;
        }, 10000);
        const options = {
            method: 'GET',
            signal: controller.signal,
            headers: {
                'Authorization': `Bearer ${this.authToken}`,
                'X-User-ID': this.userId,
            },
        };
        const response = await fetch(`${this.hydraEndpoint}`, options);
        const data = await response.json();
        if (data && (data.isEntitled || data.isInternal)) {
            sessionStorage.setItem('ifd-access', 'true');
            clearTimeout(timeoutId);
            return true;
        }
        else {
            sessionStorage.setItem('ifd-access', 'false');
            clearTimeout(timeoutId);
            return false;
        }
    }
};
CpAskRedHat.styles = [styles];
__decorate([
    property({ attribute: false })
], CpAskRedHat.prototype, "href", void 0);
__decorate([
    property({ attribute: false })
], CpAskRedHat.prototype, "healthCheckEndpoint", void 0);
__decorate([
    property({ attribute: false })
], CpAskRedHat.prototype, "hydraEndpoint", void 0);
__decorate([
    property({ attribute: false })
], CpAskRedHat.prototype, "authToken", void 0);
__decorate([
    property({ attribute: false })
], CpAskRedHat.prototype, "userId", void 0);
__decorate([
    state()
], CpAskRedHat.prototype, "hasAccess", void 0);
CpAskRedHat = __decorate([
    customElement('cp-ask-red-hat')
], CpAskRedHat);
export { CpAskRedHat };
//# sourceMappingURL=cp-ask-red-hat.src.js.map